import React from "react"
import mainLogo from './assets/mainLogo.png'
import SNSButtonList from "./SNSButtonList";
import mainStoreImg from './assets/main_store_img.png'
const FirstPage: React.FC = () => {

    return (
        <div className={'page_section'}>
            <div className={'container first_page_wrapper'}>
                <div className={'logo'}>
                    <img src={mainLogo} alt={'logo'}/>
                    <div className={'subtitle'}>
                        <h1>Premium Cat Multi-Sale Shop</h1>
                    </div>
                </div>
                <div className={'store_img_wrapper'}>
                    <img src={mainStoreImg} alt={'main_store_img'}/>
                </div>
                <SNSButtonList/>
                <div className={'store_time_box'}>
                    <h2><strong>OPEN</strong> AM 11:00 - <strong>CLOSED</strong> PM 21:00</h2>
                </div>
                <div className={'address_box'}>
                    <h1>충북 청주시 청원구 율량로 162 묘하우스</h1>
                    <h1>010-8074-3931</h1>
                </div>
            </div>
        </div>
    )
}


export default FirstPage